module.exports = __webpack_public_path__ + "static/media/student talent.87ec51e7.svg";